(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9742],{

/***/ 64923:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return __webpack_require__(26848);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ButtonBack; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6171);


const ButtonBack = (param)=>{
    let { onClick , text ="戻る" , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mt-[70px] font-bold ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center gap-1 text-[#00C4C4] text-base hover:cursor-pointer",
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: text
                })
            ]
        })
    });
};


/***/ }),

/***/ 60907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ CommonButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51857);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50888);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11382);




const CommonButton = (param)=>{
    let { minWidth ="200px" , size ="normal" , type , children , className , loading =false , disabled =false , submit =true , colorLoading ="white" , ...props } = param;
    const antIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        style: {
            fontSize: 24,
            color: colorLoading
        },
        spin: true
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                ...props,
                type: submit ? "submit" : "button",
                disabled: loading || disabled,
                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "77d55b610c70874b",
                        [
                            minWidth
                        ]
                    ]
                ]) + " " + (props && props.className != null && props.className || "button ".concat(type, " ").concat(className || "", " ").concat(size)),
                children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    indicator: antIcon
                }) : children
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "77d55b610c70874b",
                dynamic: [
                    minWidth
                ],
                children: ".button.__jsx-style-dynamic-selector{font-weight:400;font-size:16px;line-height:24px;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;height:40px;-webkit-transition:all.3s;-moz-transition:all.3s;-o-transition:all.3s;transition:all.3s}.button.__jsx-style-dynamic-selector:hover{cursor:pointer}.button.__jsx-style-dynamic-selector:not(.min-w-auto){min-width:200px;min-width:".concat(minWidth, "}.b-radius-sm.__jsx-style-dynamic-selector{-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}.small.__jsx-style-dynamic-selector{height:35px}.button.__jsx-style-dynamic-selector:hover{opacity:.8}.primary.__jsx-style-dynamic-selector{background-color:#00c4c4;color:#fff;border:1px solid#00c4c4;-webkit-box-shadow:0px 4px 8px#00000065;-moz-box-shadow:0px 4px 8px#00000065;box-shadow:0px 4px 8px#00000065}.primary-dark.__jsx-style-dynamic-selector{background-color:#2f9191;color:#fff;border:1px solid#2f9191;-webkit-box-shadow:0px 4px 8px#00000065;-moz-box-shadow:0px 4px 8px#00000065;box-shadow:0px 4px 8px#00000065}.secondary.__jsx-style-dynamic-selector{background-color:#ffba00;color:#fff}.danger.__jsx-style-dynamic-selector{background-color:#f00;color:#fff}.indigo.__jsx-style-dynamic-selector{background-color:#4fe8e8;color:#fff;border:1px solid ##90e7e7;-webkit-box-shadow:0px 4px 8px#00000065;-moz-box-shadow:0px 4px 8px#00000065;box-shadow:0px 4px 8px#00000065}.neutral.__jsx-style-dynamic-selector{background-color:#693f00;color:#fff;border:2px solid#693f00}.link.__jsx-style-dynamic-selector{background-color:#fff;color:#00c4c4;border:3px solid#fff;font-weight:bold}.cancel.__jsx-style-dynamic-selector{background-color:#fff;color:#693f00;font-size:14px;font-weight:bold;border:3px solid#fff}button.__jsx-style-dynamic-selector:disabled,button[disabled].__jsx-style-dynamic-selector{border:1px solid#ccc;background-color:#ccc;color:#666;cursor:not-allowed}")
            })
        ]
    });
};


/***/ }),

/***/ 65060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ FormButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86010);


const FormButton = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("text-center mt-10 md:mt-[60px]", className),
        children: children
    });
};


/***/ }),

/***/ 88387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ FormSearchTable; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86010);


const FormSearchTable = (param)=>{
    let { label , children , className , error , helperText , errorStyle , required =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("flex items-stretch lg:gap-2 mt-20 flex-wrap lg:flex-nowrap", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "lg:min-w-[250px] lg:w-[250px] w-full lg:bg-[#C3C3C3] flex items-center justify-between px-2 lg:px-5 flex-shrink-0 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-base text-[#5D5D5D] font-bold",
                        children: label
                    }),
                    required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-xs text-[#FF0000] whitespace-nowrap text-right",
                        children: "＊必須"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "bg-[#ECECEC] flex-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "px-[10px] py-5",
                    children: [
                        children,
                        !!error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-left mt-2 ".concat(errorStyle !== null && errorStyle !== void 0 ? errorStyle : "text-xs text-[#ff0909]"),
                            children: error
                        }),
                        !!helperText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-left mt-2 ".concat(errorStyle !== null && errorStyle !== void 0 ? errorStyle : "text-xs text-primary"),
                            children: helperText
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 69366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ PageTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const PageTitle = (param)=>/*#__PURE__*/ {
    let { text , className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "text-[#5D5D5D] text-xl md:text-3xl ".concat(className),
        children: text
    });
};


/***/ }),

/***/ 2738:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const pageListAuthen = {
    login: {
        text: "ログイン",
        url: "/login"
    },
    forgotPassword: {
        text: "パスワード再発行申請",
        url: "/forgot-password"
    },
    resetPassword: {
        text: "パスワード再設定",
        url: "/reset-password"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (pageListAuthen);


/***/ }),

/***/ 26848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ForgotPasswordPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/containers/app-layout/index.tsx + 4 modules
var app_layout = __webpack_require__(22645);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(12461);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 12 modules
var input = __webpack_require__(16333);
// EXTERNAL MODULE: ./api/index.ts + 36 modules
var api = __webpack_require__(19774);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/common/components/buttons/index.tsx
var buttons = __webpack_require__(60907);
// EXTERNAL MODULE: ./src/common/components/buttons/button-back.tsx
var button_back = __webpack_require__(36153);
// EXTERNAL MODULE: ./src/common/components/forms/form-button.tsx
var form_button = __webpack_require__(65060);
// EXTERNAL MODULE: ./src/common/components/forms/form-search-table.tsx
var form_search_table = __webpack_require__(88387);
// EXTERNAL MODULE: ./src/common/components/page-title/index.tsx
var page_title = __webpack_require__(69366);
// EXTERNAL MODULE: ./node_modules/antd/es/result/index.js + 5 modules
var result = __webpack_require__(33859);
;// CONCATENATED MODULE: ./src/common/components/result-component/index.tsx


const ResultComponent = (param)=>{
    let { status , title , subTitle , extra  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(result/* default */.ZP, {
        status: status,
        title: title,
        subTitle: subTitle,
        extra: extra
    });
};

// EXTERNAL MODULE: ./src/common/helpers/page/authen.ts
var authen = __webpack_require__(2738);
;// CONCATENATED MODULE: ./src/containers/forgot-password/index.tsx














const ForgotPasswordContainer = ()=>{
    var _errors_username, _errors_email;
    const { control , handleSubmit , formState: { errors  }  } = (0,index_esm/* useForm */.cI)();
    const [openSuccessPage, setOpenSuccessPage] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(false);
    const onSubmit = async (data)=>{
        setLoading(true);
        try {
            const transferData = {
                username: data.username,
                email: data.email
            };
            await api/* PasswordService.postV1CompanyCommonUsersForgetPassword */.CT.postV1CompanyCommonUsersForgetPassword({
                requestBody: transferData
            }).then(()=>{
                setOpenSuccessPage(true);
            }).catch((error)=>{
                if (error.status == 404) {
                    message/* default.error */.ZP.error("ログインID及びメールアドレスのに一致するユーザが見つかりません。");
                } else {
                    message/* default.error */.ZP.error("パスワードの再設定に失敗しました。");
                    console.error(error);
                }
            }).finally(()=>{
                setLoading(false);
            });
        } finally{}
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !openSuccessPage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: authen/* default.forgotPassword.text */.Z.forgotPassword.text
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(page_title/* PageTitle */.V, {
                    text: "パスワード再発行申請"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(form_search_table/* FormSearchTable */.c, {
                            required: true,
                            label: "ログインID",
                            className: "!mt-[30px]",
                            error: errors === null || errors === void 0 ? void 0 : (_errors_username = errors.username) === null || _errors_username === void 0 ? void 0 : _errors_username.message,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                name: "username",
                                rules: {
                                    required: "ログインIDを入力してください。",
                                    pattern: {
                                        value: /.{4,}/,
                                        message: "ログインIDは4文字以上で入力してください。"
                                    }
                                },
                                control: control,
                                render: (param)=>/*#__PURE__*/ {
                                    let { field: { onChange , value  }  } = param;
                                    return (0,jsx_runtime.jsx)(input/* default */.Z, {
                                        size: "large",
                                        onChange: onChange,
                                        value: value
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_search_table/* FormSearchTable */.c, {
                            required: true,
                            label: "メールアドレス",
                            className: "!mt-2",
                            error: errors === null || errors === void 0 ? void 0 : (_errors_email = errors.email) === null || _errors_email === void 0 ? void 0 : _errors_email.message,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    name: "email",
                                    rules: {
                                        required: "商工会議所メールアドレスを入力してください。",
                                        pattern: {
                                            value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                            message: "メールアドレスが正しくありません"
                                        }
                                    },
                                    control: control,
                                    render: (param)=>/*#__PURE__*/ {
                                        let { field: { onChange , value  }  } = param;
                                        return (0,jsx_runtime.jsx)(input/* default */.Z, {
                                            size: "large",
                                            onChange: onChange,
                                            value: value
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-2",
                                    children: [
                                        "システムに登録されているログインID及びメールアドレスをご入力のうえ、申請してください。",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "登録されているログインIDまたは、メールアドレスがご不明な場合は、",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "お手数ですがシステム担当(TEL：045-671-7400 Mail：",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto:conference@yokohama-cci.or.jp",
                                            children: "conference@yokohama-cci.or.jp"
                                        }),
                                        ")",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "までお問い合わせください。"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(form_button/* FormButton */.O, {
                            className: "!mt-[50px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* CommonButton */.J, {
                                type: "primary",
                                loading: loading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-bold",
                                    children: "確認"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_back/* ButtonBack */.j, {
                            onClick: ()=>router_default().push(authen/* default.login.url */.Z.login.url)
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "パスワード再設定メールを送信しました。"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultComponent, {
                    status: "success",
                    title: "パスワード再設定メールを送信しました。",
                    subTitle: "メールに記載されているURLをクリックして、パスワードを再設定してください。"
                })
            ]
        })
    });
};
/* harmony default export */ var forgot_password = (ForgotPasswordContainer);

;// CONCATENATED MODULE: ./src/pages/forgot-password/index.tsx



function ForgotPasswordPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(forgot_password, {})
    });
}
ForgotPasswordPage.getLayout = (page)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(app_layout/* default */.Z, {
        minWidth: false,
        noMargin: true,
        children: page
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5639,4217,6333,7536,7739,2645,9774,2888,179], function() { return __webpack_exec__(64923); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);